import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import meKeys from '@/api/queries/me/keyFactory';
import { graphql } from '@/gql';
import { CreatePipelineInput, CreatePipelineMutation } from '@/gql/graphql';

const CREATE_PIPELINE_MUTATION = graphql(`
  mutation CreatePipeline($input: CreatePipelineInput!) {
    createPipeline(input: $input) {
      id
      publicId
      title
      colour
    }
  }
`);

export type CreatePipelineMutationOptions = UseMutationOptions<
  CreatePipelineMutation,
  unknown,
  CreatePipelineInput
>;

const useCreatePipeline = (
  options?: Partial<CreatePipelineMutationOptions>
) => {
  const queryClient = useQueryClient();

  return useMutation({
    ...options,
    mutationFn: (input: CreatePipelineInput) => {
      return gqlClient.request(CREATE_PIPELINE_MUTATION, { input });
    },
    onSuccess: (data, variables, context) => {
      void queryClient.invalidateQueries({
        queryKey: meKeys.accountPipelines(),
      });
      options?.onSuccess?.(data, variables, context);
    },
  });
};

export default useCreatePipeline;
